import React, { useState, useRef, useEffect } from 'react';
import { Globe, ChevronDown } from '../../components/common/Icons';
import { useLanguage } from '../../context/LanguageContext';
import CountryFlag from './CountryFlag';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = ({ dropDirection = 'up' }) => {
  const { t } = useTranslation();
  const { supportedLanguages, changeLanguage, getCurrentLanguage, isInitialized } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const currentLang = getCurrentLanguage();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLanguageSelect = (languageCode) => {
    changeLanguage(languageCode);
    setIsOpen(false);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 px-3 py-2 text-white/80 hover:text-white transition-colors bg-white/10 hover:bg-white/20 rounded-lg"
        aria-label={t('language.selectLanguage')}
      >
        <Globe className="w-4 h-4" />
        <span className="hidden sm:inline text-sm font-medium flex items-center space-x-2">
          <CountryFlag countryCode={currentLang.flag} size="w-4 h-3" />
          <span className={!isInitialized ? 'opacity-50' : ''}>{currentLang.name}</span>
        </span>
        <span className="sm:hidden">
          <CountryFlag countryCode={currentLang.flag} size="w-4 h-3" />
        </span>
        <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <div className={`absolute right-0 w-48 bg-zinc-800 rounded-xl shadow-2xl border border-zinc-700 z-40 overflow-hidden ${
          dropDirection === 'down' 
            ? 'top-full mt-2' 
            : 'bottom-full mb-2'
        }`}>
          <div className="py-2">
            {supportedLanguages.map((language) => (
              <button
                key={language.code}
                onClick={() => handleLanguageSelect(language.code)}
                className={`w-full px-4 py-3 text-left hover:bg-gray-50 dark:hover:bg-zinc-700 transition-colors flex items-center space-x-3 ${
                  currentLang.code === language.code 
                    ? 'bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400' 
                    : 'text-gray-700 dark:text-gray-300'
                }`}
              >
                <CountryFlag countryCode={language.flag} size="w-5 h-4" />
                <span className="font-medium">{language.name}</span>
                {currentLang.code === language.code && (
                  <div className="ml-auto w-2 h-2 bg-blue-600 dark:bg-blue-400 rounded-full"></div>
                )}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
